import { render, staticRenderFns } from "./EraList.vue?vue&type=template&id=c22b7876&scoped=true&"
import script from "./EraList.vue?vue&type=script&lang=js&"
export * from "./EraList.vue?vue&type=script&lang=js&"
import style0 from "./EraList.vue?vue&type=style&index=0&id=c22b7876&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22b7876",
  null
  
)

export default component.exports